<template>
  <div class="print">
    <header-top :headerText="headerText" showBack></header-top>
    <div class="print-main" v-loading="loading">
      <div class="print-box" id="Print" :class="{'box-shadow':!isBtnLoading}">
        <div class="employe-info" v-if="employe.name">
          <div class="info-header">
            <img
              class="head-img"
              :src="employe.photoUrl?employe.photoUrl+'?'+new Date().getTime():defaultHead"
              crossorigin="anonymous"
            />
            <div class="header-box">
              <div class="header-name">
                <span>{{employe.name}}</span>
                <span class="header-lock" v-if="employe.isLockout">已冻结</span>
                <span class="header-emid">{{employe.emId}}</span>
              </div>
              <div class="header-detail">
                <span>{{employe.organizationUnit}}-{{employe.post}}-{{employe.position}}</span>
                <span>&nbsp;│&nbsp;{{employe.status}}</span>
                <span v-if="employe.isTrainingTeacher">&nbsp;│&nbsp;{{employe.trainingTeacherGrade}}</span>
              </div>
              <div class="header-contact">
                <span>
                  <i class="el-icon-mobile-phone"></i>
                  {{phone}}
                </span>
                <span>
                  <i class="el-icon-message"></i>
                  {{employe.email}}
                </span>
              </div>
              <div
                v-if="employe.firstWorkTime"
              >首次入职时间/最近入职时间：{{employe.firstWorkTime|getTime}}/{{employe.workTime|getTime}}</div>
              <div v-else>入职时间：{{employe.workTime|getTime}}</div>
              <div class="header-tags" v-if="employe.tags.length>0">
                <div class="header-tag" v-for="(item,index) in employe.tags" :key="index">{{item}}</div>
              </div>
            </div>
          </div>

          <el-form label-position="left" label-width="6rem">
            <div class="basic-info">
              <div class="info-title">基本信息</div>
              <div class="info-main">
                <div class="main-item">
                  <el-form-item label="姓名">{{employe.name|nullValue}}</el-form-item>
                  <el-form-item label="工号">{{employe.emId}}</el-form-item>
                  <el-form-item label="出生日期">{{employe.birthday|getTime}}</el-form-item>
                  <el-form-item label="婚姻状况">{{employe.marriageStatus|nullValue}}</el-form-item>
                  <el-form-item label="籍贯">{{employe.native|nullValue}}</el-form-item>
                  <el-form-item label="招聘渠道">{{employe.recruitWay|nullValue}}</el-form-item>
                  <el-form-item label="创建时间">{{employe.creationTime}}</el-form-item>
                  <el-form-item label="最近更新时间">{{employe.lastModificationTime}}</el-form-item>
                </div>
                <div class="main-item">
                  <el-form-item label="性别">{{employe.sex}}</el-form-item>
                  <el-form-item label="身份证号">{{idCard}}</el-form-item>
                  <el-form-item label="账号锁定">
                    <div v-if="employe.isLockout">已锁定</div>
                    <div v-else>正常</div>
                  </el-form-item>
                  <el-form-item label="民族">{{employe.nation|nullValue}}</el-form-item>
                  <el-form-item label="政治面貌">{{employe.political|nullValue}}</el-form-item>
                  <el-form-item label="家庭住址">{{employe.familyAddress|nullValue}}</el-form-item>
                  <el-form-item label="现居住地">{{employe.currentAddress|nullValue}}</el-form-item>
                  <el-form-item v-if="employe.more" label="备注">{{employe.more}}</el-form-item>
                </div>
              </div>
            </div>
            <div class="basic-info">
              <div class="info-title">联系方式</div>
              <div class="info-main">
                <div class="main-item">
                  <el-form-item label="手机号">{{employe.phoneNumber}}</el-form-item>
                  <el-form-item label="QQ账号">{{employe.qq|nullValue}}</el-form-item>
                  <el-form-item label="紧急联系人">{{employe.contactName|nullValue}}</el-form-item>
                  <el-form-item label="与联系人关系">{{employe.contactRelationship|nullValue}}</el-form-item>
                </div>
                <div class="main-item">
                  <el-form-item label="微信号">{{employe.wechat|nullValue}}</el-form-item>
                  <el-form-item label="邮箱">{{employe.email|nullValue}}</el-form-item>
                  <el-form-item label="紧急联系电话">{{contactPhone}}</el-form-item>
                </div>
              </div>
            </div>
            <div class="basic-info">
              <div class="info-title">员工状态</div>
              <div class="info-main">
                <div class="main-item">
                  <el-form-item label="状态">{{employe.status|nullValue}}</el-form-item>
                  <el-form-item
                    :label="employe.status+'限'"
                    v-if="employe.status=='试用期'||employe.status=='复岗期'"
                  >{{employe.tryWorkDays|filterTryDays}}</el-form-item>
                  <el-form-item
                    label="转正日期"
                    v-if="employe.status=='正式员工'||employe.status=='已离职'"
                  >{{employe.regularWorkTime|getTime}}</el-form-item>
                  <el-form-item label="预计转正日期" v-else>{{employe.regularWorkTime|getTime}}</el-form-item>
                  <div v-if="employe.status=='已离职'">
                    <el-form-item label="离职时间">{{employe.firedTime|getTime}}</el-form-item>
                    <el-form-item label="离职原因">{{employe.firedReason|nullValue}}</el-form-item>
                  </div>
                  <el-form-item
                    label="转正考试"
                    v-if="employe.status!='试用期'&&employe.status!='已离职'"
                  >{{employe.hasPassedRegularWorkTest?'通过':'未通过'}}</el-form-item>
                </div>
                <div class="main-item">
                  <el-form-item label="入职日期">{{employe.workTime|getTime}}</el-form-item>
                  <el-form-item label="工龄">{{employe.currentWorkingTime}}</el-form-item>
                  <el-form-item
                    label="转正考试"
                    v-if="employe.status=='试用期'||employe.status=='已离职'"
                  >{{employe.hasPassedRegularWorkTest?'通过':'未通过'}}</el-form-item>
                </div>
              </div>
            </div>
            <div class="basic-info">
              <div class="info-title">岗位信息</div>
              <div class="job-box" v-for="(item,index) in jobs" :key="index">
                <div class="job-title">
                  <span v-if="jobs.length>1">{{index+1}}.</span>
                  <span>{{item.organizationUnit.name}}-{{item.post.name}}-{{item.position.name}}</span>
                  <span v-if="item.isMajor" class="major-job">主岗位</span>
                </div>
                <div class="info-main">
                  <div class="main-item">
                    <el-form-item label="部门">{{item.organizationUnit.name}}</el-form-item>
                    <el-form-item label="生效时间">{{item.effectiveTime|getTime}}</el-form-item>
                  </div>
                  <div class="main-item">
                    <el-form-item label="职务/职级">{{item.post.name}}/{{item.position.name}}</el-form-item>
                    <el-form-item label="备注">{{item.more|nullValue}}</el-form-item>
                  </div>
                </div>
              </div>
            </div>
            <div class="basic-info">
              <div class="info-title">社保信息</div>
              <div class="info-main">
                <div class="main-item">
                  <el-form-item label="工资卡号">{{employe.cardNumber|nullValue}}</el-form-item>
                  <el-form-item label="银行">{{employe.cardBank|nullValue}}</el-form-item>
                  <el-form-item label="所属城市">{{employe.cardCity|nullValue}}</el-form-item>
                </div>
                <div class="main-item">
                  <el-form-item label="支行">{{employe.cardBankName|nullValue}}</el-form-item>
                  <el-form-item label="是否参保">{{employe.hasJoinedSocialInsurance?'是':'否'}}</el-form-item>
                </div>
              </div>
            </div>
            <div class="basic-info">
              <div class="info-title">教育信息</div>
              <div class="info-main">
                <div class="main-item">
                  <el-form-item label="学历">{{employe.educationType|nullValue}}</el-form-item>
                  <el-form-item label="专业">{{employe.profession|nullValue}}</el-form-item>
                </div>
                <div class="main-item">
                  <el-form-item label="毕业院校">{{employe.college|nullValue}}</el-form-item>
                  <el-form-item label="毕业时间">{{employe.graduationTime|getTime}}</el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="group-btn">
        <el-button type="primary" v-print="'#Print'" v-if="status=='print'">打印</el-button>
        <el-button type="primary" @click="getPDF" :loading="isBtnLoading" v-else>下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getUserDetails, getUserJobs } from "@/http/api/employe";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      id: this.$route.params.id,
      status: this.$route.params.status,
      permissions: this.$store.getters.permissions,
      jobs: [], // 岗位列表
      employe: {},
      loading: true,
      defaultHead: require("../../../../../assets/image/default-head.png"),
      isBtnLoading: false,
      isShadow: true,
      htmlTitle: "",
      isLookPhoneAuth: false, // 查看手机号权限
      isLookIdCardAuth: false, // 查看身份证权限
    };
  },
  mounted() {
    this.init(this.id);
  },
  computed: {
    phone() {
      return this.isLookPhoneAuth
        ? this.employe.phoneNumber
        : this.employe.phoneNumber.substring(0, 3) +
            "****" +
            this.employe.phoneNumber.substring(
              this.employe.phoneNumber.length - 4
            );
    },
    idCard() {
      return this.isLookIdCardAuth
        ? this.employe.identityCard
        : this.employe.identityCard[0] +
            "****************" +
            this.employe.identityCard[this.employe.identityCard.length - 1];
    },
    contactPhone() {
      return this.isLookPhoneAuth
        ? this.employe.contactPhoneNumber
        : this.employe.contactPhoneNumber.substring(0, 3) +
            "****" +
            this.employe.contactPhoneNumber.substring(
              this.employe.contactPhoneNumber.length - 4
            );
    },
    headerText() {
      return this.status == "print" ? "打印电子档案" : "下载电子档案";
    },
  },
  methods: {
    init(id) {
      // 获取员工信息
      getUserDetails(id).then((res) => {
        this.employe = res.result;
        this.htmlTitle = "电子档案-" + this.employe.name;
        this.loading = false;
      });
      // 获取用户岗位信息
      getUserJobs(id).then((res) => {
        if (res.result.items.length) {
          this.jobs = res.result.items;
          // 主岗放首位
          let index = this.jobs.findIndex((el) => {
            return el.isMajor == true;
          });
          this.jobs.unshift(this.jobs.splice(index, 1)[0]);
        }
      });

      this.isLookPhoneAuth = this.permissions[
        "RocketIdentity.Users.LookPhoneNumber"
      ];
      this.isLookIdCardAuth = this.permissions[
        "RocketIdentity.Users.LookIdCard"
      ];
    },
    getPDF() {
      this.isBtnLoading = true;
      setTimeout(() => {
        this.getPdf(this.htmlTitle);
      }, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  width: 100%;
  color: #000;

  .print-main {
    box-sizing: border-box;
    background-color: #f2f2f2;

    .print-box {
      padding: 25px;
      background-color: #ffffff;

      .employe-info {
        background-color: #ffffff;

        .info-header {
          display: flex;
          margin-bottom: 30px;

          .head-img {
            width: 142px;
            height: 165px;
          }

          .header-box {
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            margin-left: 30px;
            font-size: 13px;
            .header-name {
              display: flex;
              align-items: baseline;
              font-size: 20px;
              font-weight: bold;

              .header-lock,
              .header-emid {
                position: relative;
                top: 1px;
                margin-left: 8px;
                font-size: 13px;
                font-weight: 500;
              }

              .header-lock {
                color: #666;
              }
            }

            .header-detail {
              overflow: hidden;
              line-height: 13px;
            }

            .header-contact {
              span:first-child {
                margin-right: 10px;
              }
            }

            .header-tags {
              display: flex;
              .header-tag {
                border: 1px solid $--color-primary;
                margin-right: 6px;
                padding: 3px 6px;
                white-space: nowrap; /* 不换行 */
                color: $--color-primary;
              }
            }
          }
        }

        .basic-info {
          .info-title {
            margin-top: 10px;
            margin-bottom: 20px;
            padding-bottom: 15px;
            font-size: 17px;
            font-weight: bold;
            width: 100%;
            border-bottom: 1px solid #ddd;
          }

          .info-main {
            display: flex;

            .main-item {
              width: 50%;

              .el-form-item {
                margin-bottom: 10px;
              }
            }
          }

          .job-box {
            margin-bottom: 10px;

            .job-title {
              display: flex;
              align-items: center;
              margin-bottom: 20px;
              font-size: 15px;

              .major-job {
                height: 15px;
                margin-left: 9px;
                border: 1px solid $--color-primary;
                padding: 0 3px;

                font-size: 12px;
                font-weight: 400;
                line-height: 15px;
                color: $--color-primary;
              }
            }
          }
        }
      }

      .line {
        margin-bottom: 20px;
        width: 100%;
        height: 1px;
        background: #ddd;
      }
    }

    .box-shadow {
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    }

    .group-btn {
      margin-top: 20px;
      width: 100%;
      text-align: center;
    }
  }
}

.print {
  .print-main {
    padding: 20px;
  }
}
</style>
<style lang="scss">
@media print {
  .print-box {
    padding: 25px;
    background-color: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

    .employe-info {
      background-color: #ffffff;

      .info-header {
        display: flex;
        margin-bottom: 30px;

        .head-img {
          width: 142px;
          height: 165px;
        }

        .header-box {
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          margin-left: 30px;
          font-size: 13px;
          .header-name {
            display: flex;
            align-items: baseline;
            font-size: 20px;
            font-weight: bold;

            .header-lock,
            .header-emid {
              position: relative;
              top: 1px;
              margin-left: 8px;
              font-size: 13px;
              font-weight: 500;
            }

            .header-lock {
              color: #666;
            }
          }

          .header-detail {
            overflow: hidden;
            line-height: 13px;
          }

          .header-contact {
            span:first-child {
              margin-right: 10px;
            }
          }

          .header-tags {
            display: flex;
            .header-tag {
              border: 1px solid $--color-primary;
              margin-right: 6px;
              padding: 3px 6px;
              white-space: nowrap; /* 不换行 */
              color: $--color-primary;
            }
          }
        }
      }

      .basic-info {
        .info-title {
          margin-top: 10px;
          margin-bottom: 20px;
          padding-bottom: 15px;
          font-size: 17px;
          font-weight: bold;
          width: 100%;
          border-bottom: 1px solid #ddd;
        }

        .info-main {
          display: flex;

          .main-item {
            width: 50%;

            .el-form-item {
              margin-bottom: 10px;

              .lockout-box {
                display: flex;
                align-items: center;

                .svg-icon {
                  margin-right: 5px;
                }
              }

              .is-lockout {
                color: #f44242;
              }

              .not-lockout {
                color: #0abf5b;
              }
            }
          }
        }

        .job-box {
          margin-bottom: 10px;

          .job-title {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            font-size: 15px;

            .major-job {
              height: 15px;
              margin-left: 9px;
              border: 1px solid $--color-primary;
              padding: 0 3px;

              font-size: 12px;
              font-weight: 400;
              line-height: 15px;
              color: $--color-primary;
            }
          }
        }
      }
    }

    .line {
      margin-bottom: 20px;
      width: 100%;
      height: 1px;
      background: #ddd;
    }
  }
}
</style>